import { ReactComponent as LogoutIconSVG } from "./logout.svg";
import { SvgIcon } from '@mui/material';

export default function IconLogout(props) {
  return <SvgIcon {...props} component={LogoutIconSVG} viewBox="0 0 17 14" />;
}